"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * RedPanda UI - Alert Component
 * 統一的警告/通知元件，使用設計 token
 */
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../utils");
const class_variance_authority_1 = require("class-variance-authority");
const alertVariants = (0, class_variance_authority_1.cva)('p-4 mb-6 border-l-4 rounded-sm', // 基礎樣式，對應原來的 padding: 1rem, marginBottom: 1.5rem, borderLeftWidth: 4px, borderRadius: 0.25rem
{
    variants: {
        variant: {
            // 保持與現有元件完全相同的視覺效果，但使用內聯樣式來精確匹配
            info: 'bg-[#e6f7ff] border-[#91d5ff] text-[#005288]',
            warning: 'bg-[#fffbe6] border-[#ffe58f] text-[#8a6d3b]',
            success: 'bg-[#f6ffed] border-[#b7eb8f] text-[#389e0d]',
            error: 'bg-[#fff1f0] border-[#ffa39e] text-[#cf1322]',
        }
    },
    defaultVariants: {
        variant: 'info'
    }
});
exports.Alert = react_1.default.forwardRef(({ className, variant = 'info', title, children, ...props }, ref) => ((0, jsx_runtime_1.jsxs)("div", { ref: ref, role: "alert", className: (0, utils_1.cn)(alertVariants({ variant }), className), ...props, children: [(0, jsx_runtime_1.jsx)("p", { className: "font-bold mb-1", children: title }), (0, jsx_runtime_1.jsx)("div", { children: children })] })));
exports.Alert.displayName = 'Alert';
